import * as React from "react";
import { SVGProps } from "react";

export const IconMissingParticipants = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_1138_5709)">
      <path
        d="M19.6 14.573L12.593 2.436C11.45.431 8.555.431 7.414 2.436L.404 14.573c-1.145 2.005.28 4.495 2.589 4.495h13.993c2.31 0 3.759-2.515 2.614-4.495zM10 16.376c-.61 0-1.116-.507-1.116-1.116 0-.61.506-1.115 1.116-1.115.609 0 1.115.506 1.09 1.144.03.58-.506 1.087-1.09 1.087zm1.017-7.213c-.05.865-.103 1.725-.153 2.59-.024.28-.024.535-.024.81a.84.84 0 01-.84.812.822.822 0 01-.84-.787c-.074-1.346-.152-2.667-.227-4.014-.024-.354-.049-.712-.078-1.066 0-.584.33-1.066.865-1.218a1.12 1.12 0 011.297.634c.078.177.103.354.103.56-.025.564-.079 1.123-.103 1.68z"
        fill="#FCDB73"
      />
    </g>
    <defs>
      <clipPath id="clip0_1138_5709">
        <path fill="#fff" d="M0 0H20V20H0z" />
      </clipPath>
    </defs>
  </svg>
);
